import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_ORDER_STATUS_LIBRARY = gql`
  mutation UpdateOrderStatusLibrary(
    $where: OrderUniqueInput!
    $data: UpdateOrderStatusLibraryInput
  ) {
    updateOrderStatusLibrary(where: $where, data: $data) {
      message
    }
  }
`;

export const CANCEL_ORDER_LIBRARY = gql`
  mutation CancelOrderLibrary(
    $where: OrderUniqueInput!
    $data: CancelledOrderByLibraryInput
  ) {
    cancelOrderLibrary(where: $where, data: $data) {
      message
    }
  }
`;

export const REQUEST_NEW_ORDER_EXPORT = gql`
  mutation RequestNewOrderExport($data: RequestExportInput!) {
    requestNewOrderExport(data: $data) {
      message
    }
  }
`;

export const REQUEST_NEW_RETURN_ORDER_EXPORT = gql`
  mutation RequestReturnOrderExport(
    $data: RequestExportInput!
    $filter: ReturnOrderExportFilter
  ) {
    requestReturnOrderExport(data: $data, filter: $filter) {
      message
    }
  }
`;

export const ASSIGN_DELIVERY_PARTNER_TO_RETURN_ORDER = gql`
  mutation AssignDeliveryPartnerToReturnOrder(
    $data: AssignDeliveryPartnerToReturnOrderInput
    $where: AssignDeliveryPartnerToReturnOrderWhereInput!
  ) {
    assignDeliveryPartnerToReturnOrder(data: $data, where: $where) {
      message
    }
  }
`;

export const SYNC_ORDER_ITEM_STAFF_ASSIGNMENT = gql`
  mutation SyncOrderItemStaffAssignment(
    $where: SyncOrderItemStaffAssignmentWhereInput
    $data: SyncOrderItemStaffAssignmentInput
  ) {
    syncOrderItemStaffAssignment(where: $where, data: $data) {
      message
    }
  }
`;
